"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const account_1 = __importDefault(require("./account"));
require("./index.css");
function registerScript() {
    (function ($) {
        $(document).ready(function () {
            const form = document.getElementById("register-form");
            // validate form
            if (form) {
                form.addEventListener("submit", function (event) {
                    event.preventDefault();
                    const username = document.getElementById("username");
                    const email = document.getElementById("email");
                    const password = document.getElementById("password");
                    const confirmPassword = document.getElementById("confirm-password");
                    if (email && password && confirmPassword) {
                        if (password.value !== confirmPassword.value) {
                            alert("Password dan konfirmasi password tidak sama");
                            return;
                        }
                    }
                    if (username && email && password && confirmPassword) {
                        const data = {
                            action: "sakinah_register_validation",
                            nonce: window.sakinahPublic.nonce,
                            username: username.value,
                            email: email.value,
                            password: password.value,
                        };
                        $.post(window.sakinahPublic.ajaxUrl, data, function (response) {
                            if (response.success) {
                                form.submit();
                            }
                            else {
                                alert(response.data);
                            }
                        });
                    }
                });
            }
            $(".register-back").on("click", function () {
                $("#step2").css("height", "0");
                $("#step2").css("visibility", "hidden");
                $("#step1").show();
            });
            $(".dd-button").on("click", function () {
                if ($(".dd-content").css("display") === "none") {
                    $(".dd-content").show();
                }
                else {
                    $(".dd-content").hide();
                }
            });
            // Close the dropdown if the user clicks outside of it
            $(document).on("click", function (e) {
                if (!$(e.target).closest(".dd-button").length) {
                    $(".dd-content").hide();
                }
            });
        });
    })(window.jQuery);
}
registerScript();
(0, account_1.default)();
